import React from "react";
import CheckDefecto from './CheckDefecto';

const OpcionDefecto = ({ infoData, referencia, valorCombo, valorChecked, selecciono, selectCheckBox, selectCombo }) => {
    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Opci\u00F3n por defecto"}</label>
            </div>
            <div className="col-xs-6">
                <div className="container-radio radio-margin">
                    <select className="form-control default-select" value={valorCombo} onChange={(event) => {
                        const index = event.target.selectedIndex;
                        const value = event.target.options[index].value;

                        selectCombo(value);
                    }}>
                        <option key={0} value={0}>Seleccione...</option>
                        {infoData.map(item => <option key={item.Id} value={item.Id}>{item.Descripcion}</option>)}}
                    </select>

                    <CheckDefecto
                        referencia={referencia}
                        check={valorChecked}
                        selectCheckBox={(event) => selectCheckBox(event.target.checked)}
                    />
                </div>
            </div>
            <div className="col-xs-12">
                {([null, 0].some(c => c == valorCombo) && selecciono>0 && valorChecked || valorChecked && selecciono>0 && !infoData.some(e=>e.Checked && e.Id == valorCombo )) &&
                    <label className="error">{"Debe seleccionar una opci\u00F3n por defecto"}</label>}
            </div>
        </div>
    );
}

export default OpcionDefecto;